import { render } from "./ChartTab.vue?vue&type=template&id=4c7d381b&scoped=true"
import script from "./ChartTab.vue?vue&type=script&lang=js"
export * from "./ChartTab.vue?vue&type=script&lang=js"

import "./ChartTab.vue?vue&type=style&index=0&id=4c7d381b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7d381b"]])

export default __exports__